import type { ConfigApi, OAuthApi } from '@backstage/frontend-plugin-api';

import { createApiRef } from '@backstage/frontend-plugin-api';

type App = {
  id: string;
  logo: string;
  title: string;
  url: string;
};

export const appSwitcherApiRef = createApiRef<AppSwitcherApi>().with({
  id: 'plugin.ipen.app-switcher.api',
});

export class AppSwitcherApi {
  private readonly baseUrl: string | undefined;
  private readonly clientId: string | undefined;
  private readonly microsoftAuthApi: OAuthApi;

  constructor({ config, microsoftAuthApi }: { config: ConfigApi; microsoftAuthApi: OAuthApi }) {
    this.microsoftAuthApi = microsoftAuthApi;
    this.clientId = config.getOptionalString('ipen.microsoft.clientId');
    this.baseUrl = config.getOptionalString('ipen.appSwitcherUrl');
  }

  async getApps() {
    return await this.fetch<App[]>('/apps');
  }

  private async fetch<T = unknown>(
    input: string,
    init?: RequestInit,
  ): Promise<T> {
    if (!this.clientId) {
      throw new Error(
        'Microsoft clientId is not configured at ipen.microsoft.clientId',
      );
    }

    if (!this.baseUrl) {
      throw new Error(
        'AppSwitcher baseUrl is not configured at ipen.appSwitcherUrl',
      );
    }

    const headers = new Headers(init?.headers);
    const token =
      await this.microsoftAuthApi.getAccessToken(`api://${this.clientId}/ipen.solution`);

    headers.set('Authorization', `Bearer ${token}`);

    const response = await fetch(`${this.baseUrl}${input}`, {
      ...init,
      headers,
    });
    if (!response.ok) throw new Error(response.statusText);
    return (await response.json()) as T;
  }
}
